import AddFundsButton from '../lib/add_funds_button';

const InvoiceAddFunds = (props) => (<AddFundsButton btnClass="btn-primary btn" {...props} />);

export default InvoiceAddFunds;
